import React from 'react';
import QRCodeReader from '@components/QRCode';

const getHostName = () => {
  switch (window.location.hostname) {
    case 'tweb.dev.onedine.com': return 'app.dev.onedine.com';
    case 'tweb.uat.onedine.com': return 'app.uat.onedine.com';
    case 'tweb.onedine.com': return 'app.onedine.com';
    default: return 'app.uat.onedine.com';
  }
};

const QrPayFromPhone = () => {
  const check = JSON.parse(window.sessionStorage.getItem('seat'));
  return (
    <div className="col-12 h-100">
      <div className="h-80 py-2">
        <div className="h-100">
          <QRCodeReader
            qrcode={`https://${getHostName()}/checkIn/6/${check?.id}/${check?.referenceId}/`}
            size={600}
          />
        </div>
      </div>
      {/* <div className="col-12 p-0 h-40 py-2 fs-18 od-text-primary text-primary row mx-0 align-items-end">
        <div className="col-12 px-0 text-center">{CUSTOM_MESSAGES().SCAN_QR_CODE_INFO}</div>
        <div className="col-12 px-0 text-center">{CUSTOM_MESSAGES().COMPLETE_PAYMENT_AND_CONTINUE}</div>
        <button
          type="button"
          className="btn btn70 rounded od-btn-primary my-1 btn-primary btn-ripple w-100"
          onClick={() => handleCheck('qrPayRoute')}
        >
          <div className="fs-18">{LABEL().CONTINUE}</div>
        </button>
      </div> */}
    </div>
  );
};

export default QrPayFromPhone;
